import { StyledButton } from "./ValidateButton.styles";

type Props = {
    text: string;
    // Inactive, but kept focusable (aria-disabled rather than disabled) so
    // keyboard focus is not lost when the button becomes inactive (RGAA 12.8)
    isDisabled: boolean;
    // "Modifier le vote": the colors of "Valider le vote", inverted.
    isOutlined?: boolean;
    onClick: () => void;
};

const ValidateButton = ({
    isDisabled,
    isOutlined = false,
    text,
    onClick,
}: Props) => {
    function handleClick() {
        if (isDisabled) {
            return;
        }
        onClick();
    }

    return (
        <StyledButton
            $isOutlined={isOutlined}
            aria-disabled={isDisabled || undefined}
            onClick={handleClick}
            data-testid="btn-validate-votebox"
        >
            {text}
        </StyledButton>
    );
};

export default ValidateButton;
